/**
 * Created by Jan on 21.02.2017.
 */


(function (Lfl, $, undefined) {
    /**
     * TODO MOBA II - rename to HTTP?
     * @memberOf Lfl
     */
    Lfl.Urls = Lfl.Urls || {};

    (function (Urls, $, undefined) {
        if (Lfl.Files.isLoadedAlready(Lfl.Urls, 'ParametersProcessor')) {
            return;
        }

        /*
         |==============================================================================================================
         | Documentation
         |==============================================================================================================
         */

        /**
         * Helps parsing out parameters from the URL and work with them.
         *
         * @memberOf Lfl.Urls
         */
        Lfl.Urls.ParametersProcessor = Urls.ParametersProcessor || {};

        (function (ParametersProcessor, $, undefined) {
            /*
             |===========================================================================================================
             | Object definition
             |===========================================================================================================
             */

            /*
             |-----------------------------------------------------------------------------------------------------------
             | Public methods
             |-----------------------------------------------------------------------------------------------------------
             */

            /**
             * Provides an object containing name-indexed URL search parameters (Which translate to GET parameters in
             * PHP ).
             *
             * Source: http://stackoverflow.com/a/21152762/5500468
             *
             * @memberOf Lfl.Urls.ParametersProcessor
             * @param {string} [url] The whole url.
             * @return {Object<String, String[] >}
             */
            ParametersProcessor.getSearchParameters = function (url) {
                if (typeof url === 'undefined') {
                    url = window.location.href;
                }

                if (true !== doesUrlHaveQueryString(url)) {
                    return {};
                }

                var search = getQueryStringFromUrl(url);

                var qd = {};

                // TODO MOBA II - do not allow multiple values per key. It's just confusing and seems like bad practice.
                search.substr(1).split("&").forEach(function (item) {
                    var s = item.split("="),
                        k = s[0],
                        v = s[1] && decodeURIComponent(s[1]);
                    //(k in qd) ? qd[k].push(v) : qd[k] = [v]
                    (qd[k] = qd[k] || []).push(v); //short-circuit
                });

                return qd;
            };


            /**
             * Adds the given name=value pair to the query string of the URL.
             *
             * Adds the name a second time if it is already present, but adds nothing if it is present with this exact
             * value.
             *
             * @memberOf Lfl.Urls.ParametersProcessor
             * @param {string} [url] The whole url.
             * @param {string} name Name of the parameter (the "key")
             * @param {string} value
             * @return {string}
             */
            ParametersProcessor.addSearchParameter = function (url, name, value) {
                var newQuery = name + "=" + value;
                if (url.indexOf(newQuery) !== -1) {
                    return url;
                }

                var urlWithQueryString;
                if (doesUrlHaveQueryString(url)) {
                    urlWithQueryString = url + "&";
                } else {
                    urlWithQueryString = url + "?";
                }

                return urlWithQueryString + newQuery;
            };

            /**
             * Removes all parameters of this name (if the parameter is present multiple times).
             * TODO MOBA II / TODO JS - add a "value" parameter that will allow to remove one specific key value combination
             * @memberOf Lfl.Urls.ParametersProcessor
             * @param {string} [url] The whole url.
             * @param {string} name Name of the parameter (the "key")
             * @param {string} valueToRemove
             * @return {string}
             */
            ParametersProcessor.removeSearchParameter = function (url, name, valueToRemove) {
                if (typeof url === 'undefined') {
                    url = window.location.href;
                }

                var parameters = ParametersProcessor.getSearchParameters(url);

                var baseUrl = getUrlWithoutQueryString(url);
                var resultUrl = baseUrl + "?";
                // If the & sign is to be skipped (first should be)
                var skipAnd = true;


                _.each(parameters, function (values, key) {
                    if (key != name) {
                        _.each(values, function (value, index) {
                            resultUrl += (skipAnd ? '' : '&') + key + "=" + value;
                            skipAnd = false;
                        });
                    } else {
                        _.each(values, function (value, index) {
                            if (typeof valueToRemove !== 'undefined' && valueToRemove != value) {
                                resultUrl += (skipAnd ? '' : '&') + key + "=" + value;
                                skipAnd = false;
                            }
                        });
                    }
                });

                // If no parameters were added...
                if (resultUrl == baseUrl + "?") {
                    return baseUrl;
                }

                return resultUrl;
            };

            /**
             * Checks whether given parameter can be considered as equal to true.
             *
             * @memberOf Lfl.Urls.ParametersProcessor
             * @param {string[]} value
             * @param {Array} [additionalTrueValues] Any other value which should be considered as true.
             * @param {boolean=true} enableNumeric Whether numeric value (i.e. "1") is also allowed.
             * @return {boolean}
             */
            ParametersProcessor.isTrue = function (value, additionalTrueValues, enableNumeric) {
                /*
                 |-------------------------------------------------------------------------
                 | Default values */
                if (typeof additionalTrueValues === 'undefined') {
                    additionalTrueValues = [];
                }

                if (typeof enableNumeric === 'undefined') {
                    enableNumeric = true
                }

                /*
                 |-------------------------------------------------------------------------
                 | Allowed values init */
                var allowedValues = [true, 'true'].concat(additionalTrueValues);

                if (enableNumeric === true) {
                    allowedValues = allowedValues.concat([1, "1"]);
                }

                /*
                 |-------------------------------------------------------------------------
                 | The check */
                var result = false;

                _.each(allowedValues, function (allowedValue) {
                    // TODO MOBA II - do not allow multiple values per key.
                    // The last value is the "real" one. Because there can only be one...
                    if (value[value.length - 1] === allowedValue) {
                        result = true;
                    }
                });

                return result;
            };


            /*
             |-----------------------------------------------------------------------------------------------------------
             | Private methods
             |-----------------------------------------------------------------------------------------------------------
             */

            /**
             * Provides the query string with the ? included.
             * @param {string} url
             * @returns {string}
             */
            function getQueryStringFromUrl(url) {
                return doesUrlHaveQueryString(url) ? url.substring(url.indexOf('?')) : ''; // We want the ? included.
            }

            /**
             *
             * @param {string} url
             * @returns {boolean}
             */
            function doesUrlHaveQueryString(url) {
                return url.indexOf("?") !== -1;
            }

            /**
             *
             * @param {string} url
             * @returns {string}
             */
            function getUrlWithoutQueryString(url) {
                return doesUrlHaveQueryString(url) ? url.substring(0, url.indexOf('?')) : url;
            }

        }(Urls.ParametersProcessor, jQuery));
    }(Lfl.Urls, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));